(function () {
  app.controller('CartsCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {
      $scope.shipping = {};
      $scope.error = '';
      $scope.error_billing = '';
      $scope.data_checkout = {};

      $scope.init = function () {};

      $scope.changeTab = function (tab) {
        $scope.current_tab = tab;
        switch (tab) {
          case 'order_summary':
            $scope.title = 'Order Summary';
            break;
        
          case 'checkout':
            $scope.title = 'Checkout';
            $scope.updateGtag('begin_checkout');
            break;

          case 'proceed_to_payment':
            $scope.title = 'Checkout';
            break;
        }
      }

      $scope.updateGtag = function (event_name, options = {}) {
        let o = {
          currency: 'USD',
          value: $scope.price * $scope.qty,
          items: [
            {
              item_name: $scope.box_name,
              item_id: $scope.box_slug,
              price: $scope.price,
              quantity: $scope.max_qty > 0 ? $scope.qty : 0,
              item_category: $scope.box_type
            }
          ]
        };
        gtag('event', event_name, {...o, ...options });
      }

      $scope.qtyDecrement = function () {
        $scope.qty -= 1;
        if ($scope.qty <= 0) {
          $scope.qty = 1;
        }
      }

      $scope.qtyIncrement = function () {
        if ($scope.qty + 1 > $scope.max_qty) {
          toastr.error(`The quantity remaining is ${$scope.max_qty}.`)
        } else {
          $scope.qty += 1;
        }
      }

      $scope.validateShippingForm = function() {
        // Loop through each key in shipping
        for (const key in $scope.shipping) {
          if (key !== 'shipping_address_optional' && !$scope.shipping[key]) {
            $scope.error = `Please fill out the required fields.`;
            return false; // Stop submission
          }
          if (key === 'shipping_email' && !isValidEmail($scope.shipping.shipping_email)) {
            $scope.error = 'Missing or incorrect Email format.';
            return false;
          }
          if (key === 'shipping_phone_number' && $scope.shipping.shipping_phone_number && isNaN($scope.shipping.shipping_phone_number)) {
            $scope.error = 'Phone number must be a valid number.';
            return false;
          }
          if (key === 'shipping_zip_code') {
            var zipCode = $scope.shipping.shipping_zip_code;
            if (!/^\d[\d\s\-]*$/.test(zipCode)) {  // RegEx checks for numeric, space, or hyphen
              $scope.error = 'Zip code must not contain letters.';
              return false;
            }
          }
        }
        $scope.error = '';
        return true;
      }

      $scope.validateBillingForm = function() {
        if ($scope.billing_option != 'sameAsShipping') {
          // Loop through each key in billing_address
          for (const key in $scope.billing_address) {
            if (key !== 'line2' && !$scope.billing_address[key]) {
              $scope.error_billing = `Please fill out the required fields.`;
              return false; // Stop submission
            }
            if (key === 'email' && !isValidEmail($scope.billing_address.email)) {
              $scope.error_billing = 'Missing or incorrect Email format.';
              return false;
            }
            if (key === 'phone' && $scope.billing_address.phone && isNaN($scope.billing_address.phone)) {
              $scope.error_billing = 'Phone number must be a valid number.';
              return false;
            }
            if (key === 'postal_code') {
              var zipCode = $scope.billing_address.postal_code;
              if (!/^\d[\d\s\-]*$/.test(zipCode)) {  // RegEx checks for numeric, space, or hyphen
                $scope.error_billing = 'Zip code must not contain letters.';
                return false;
              }
            }
          }
        }
        $scope.error_billing = '';
        return true;
      }

      $scope.changeBillingOption = function(value) {
        $scope.billing_option = value;
      }

      $scope.checkout = function () {
        if ($scope.validateShippingForm() && $scope.validateBillingForm()) {
          $scope.shipping.qty = $scope.qty;
          $scope.shipping.shipping_fee = $scope.shipping_fee();
          $.ajax({
            beforeSend: function(){
              // $(".loading").hide();
              // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
              // $(".loading").attr('style', 'z-index: -1 !important');
            },
            url: $scope.checkout_url,
            dataType: "json",
            cache: false,
            type: "POST",
            data: { 
              order: $scope.shipping, 
              box: $scope.box_slug, 
              store_slug: $scope.store_slug, 
              amount: $scope.price, 
              billing_option: $scope.billing_option, 
              billing_address: $scope.billing_address
            },
            success: function (rs) {
              $timeout(function () {
                if (rs.succeed) {
                  $scope.data_checkout = rs.data;
                  $scope.changeTab('proceed_to_payment');
                  $scope.updateGtag('add_shipping_info');
                  $timeout(function () {
                    $scope.getStripe();
                  });
                } else {
                  toastr.error("Whoa! An error occurred! Please try again");
                }
              });
            },
          })
        }
      }

      // Stripe's Payment Element is a cross-origin iframe: it cannot read the
      // --ws-* tokens, so its appearance is built from them here. Dark is the
      // night appearance exactly as it shipped; light resolves the tokens at
      // call time (window.wsChart.token reads <body>, where the light block is
      // scoped), and getStripe() refreshes it on ws:theme through
      // elements.update() rather than remounting the element.
      $scope.stripeAppearance = function () {
        if (!(window.wsChart && window.wsChart.isLight())) {
          return {
            theme: 'night',
            variables: {
              'fontFamily': 'Roc Grotesk, Arial, sans-serif',
              'borderRadius': '10px',
              'colorBackground': '#191919',
              'colorText': '#FFFFFF80',
              'p-colorBackgroundDeemphasize05': '#FFFFFF',
              'colorBackgroundDeemphasize05': '#FFFFFF',
            },
            rules: {
              '.Input': {
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#FFF'
              }
            }
          };
        }
        var token = window.wsChart.token;
        return {
          theme: 'stripe',
          variables: {
            'fontFamily': 'Roc Grotesk, Arial, sans-serif',
            'borderRadius': '10px',
            'colorBackground': token('--ws-menu'),
            'colorText': token('--ws-ink'),
            'colorTextSecondary': token('--ws-ink-2'),
            'colorPrimary': token('--ws-green'),
            'colorDanger': token('--ws-red'),
          },
          rules: {
            '.Input': {
              border: '1px solid ' + token('--ws-line'),
              color: token('--ws-ink')
            }
          }
        };
      }

      $scope.getStripe = function () {
        $scope.stripe = Stripe($scope.stripe_publishable_key)
        var appearance = $scope.stripeAppearance(),
            options = {
              layout: {
                type: 'tabs',
                defaultCollapsed: false,
              }
            },
            clientSecret = $scope.data_checkout.client_secret;
        var mountNode = document.getElementById('payment-element');
        $scope.elements = $scope.stripe.elements({ clientSecret, appearance }),
        $scope.paymentElement = $scope.elements.create('payment', options);
        $scope.paymentElement.mount('#payment-element');

        // One listener per mount. Turbolinks keeps the document across visits
        // but not this scope, so the handler is a local closure that unbinds
        // itself once the node it mounted on has left the document -- a later
        // page's #payment-element (the cart again, or the subscription
        // settings) must not keep it updating an unmounted Elements group. A
        // re-mount on the same page drops the previous handler first.
        if ($scope.onThemeChange) document.removeEventListener('ws:theme', $scope.onThemeChange);
        var handler = function () {
          if (!$scope.elements || !mountNode || !mountNode.isConnected) {
            document.removeEventListener('ws:theme', handler);
            return;
          }
          $scope.elements.update({ appearance: $scope.stripeAppearance() });
        };
        $scope.onThemeChange = handler;
        document.addEventListener('ws:theme', handler);
      }

      $scope.submitOrder = async function () {
        $scope.showLoading();
        let elements = $scope.elements,
            payment_method_data = {
              billing_details: {
                name: $scope.billing_address.first_name + ' ' + $scope.billing_address.last_name,
                email: $scope.billing_address.email,
                phone: $scope.billing_address.phone,
                address: {
                  line1: $scope.billing_address.line1,
                  line2: $scope.billing_address.line2,
                  city: $scope.billing_address.city,
                  state: $scope.billing_address.state,
                  postal_code: $scope.billing_address.postal_code,
                  country: "US"
                }
              }
            };
        if ($scope.billing_option == 'sameAsShipping') {
          payment_method_data = {
            billing_details: {
              name: $scope.shipping.shipping_first_name + ' ' + $scope.shipping.shipping_last_name,
              email: $scope.shipping.shipping_email ? $scope.shipping.shipping_email : $scope.email,
              phone: $scope.shipping.shipping_phone_number,
              address: {
                line1: $scope.shipping.shipping_address,
                line2: $scope.shipping.shipping_address_optional,
                city: $scope.shipping.shipping_city,
                state: $scope.shipping.shipping_state,
                postal_code: $scope.shipping.shipping_zip_code,
                country: "US"
              }
            }
          }
        }
        
        var { error, paymentIntent } = await $scope.stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: $scope.return_url,
            payment_method_data: payment_method_data
          },
          redirect: "if_required"
        });

        if (error) {
          const messageContainer = document.getElementById('error-message');
          messageContainer.textContent = error.message;
          $scope.hideLoading();
        } else {
          if (paymentIntent.status === 'succeeded') {
            $scope.updateGtag('add_payment_info', {payment_type: paymentIntent.payment_method_types[0]});
            $scope.updateGtag('purchase', {transaction_id: $scope.data_checkout.order, shipping: $scope.shipping_fee()});
            window.location.href = `${$scope.return_url}?payment_intent=${paymentIntent.id}&redirect_status=${paymentIntent.status}`;
          }
        }
      }

      $scope.showLoading = function () {
        $(".loading").show();
        $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
        $(".loading").attr('style', 'z-index: 9999 !important');
      }

      $scope.hideLoading = function () {
        $(".loading").hide();
        $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
        $(".loading").attr('style', 'z-index: -1 !important');
      }

      $scope.shipping_fee = function () {
        if (!$scope.shipping_profile || $scope.price * $scope.qty >= $scope.shipping_profile.threshold) {
          return 0;
        }

        return $scope.shipping_profile.shipping_fee;
      }

      $scope.buyNow = function (url) {
        Turbolinks.visit(url+'&qty='+$scope.qty);
      }


    }
  ]);

}).call(this);